import SAboutUs from "./SAboutUs_web"
export default SAboutUs
